export default function transformBlogPosts({ allMdx, allSanityBlogPost }) {
  return [...allMdx.nodes, ...allSanityBlogPost.nodes]
    .map(node => {
      let post = {}

      if (node.internal.type === "Mdx") {
        post = {
          ...node,
        }
      } else if (node.internal.type === "SanityBlogPost") {
        post = {
          id: node._id,
          internal: node.internal,
          timeToRead: 0,
          frontmatter: {
            slug: `/blog/${node.slug?.current}`,
            author: node.author?.name,
            summary: node.summary,
            title: node.title,
            categories: node.categories,
            date: node.publishedAt,
            featured: node.featured,

            preview_image: node.coverImage,
            social_image: node.coverImage,
          },
        }
      }

      return post
    })
    .sort((a, b) => {
      return new Date(b.frontmatter.date) - new Date(a.frontmatter.date)
    })
}
